module.exports = __webpack_public_path__ + "static/img/brees-2001-slide-1.7a36260.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2001-slide-1.jpg
// module id = IpKx
// module chunks = 1